<template>
  <div>
    <!-- 侧边浮动栏 -->
    <div class="zx_kf">
      <ul>
        <li>
          <a href="javascript:;" class="zx_ly" @click="showModal = true"><i class="iconfont icon-youxiang1"></i></a>
          <div class="click-btn">Click Here</div>
        </li>
        <li><a href="https://www.facebook.com/people/%E5%B1%B1%E4%B8%9C%E5%8D%8E%E8%AA%89%E6%9C%BA%E6%A2%B0%E8%AE%BE%E5%A4%87%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/61587418161345/" target="_blank"><i class="iconfont icon-facebook-fill"></i></a></li>
        <!-- <li><a href=""><i class="iconfont icon-youtube"></i></a></li>
        <li><a href=""><i class="iconfont icon-douyin"></i></a></li>
        <li><a href=""><i class="iconfont icon-linkedin-fill1"></i></a></li> -->
        <li><a href="javascript:;" class="f_h" @click="backToTop"><i class="iconfont icon-fanhuidingbu3"></i></a></li>
      </ul>
      <div class="fh_top" @click="backToTop"><i class="iconfont icon-fanhuidingbu3"></i></div>
    </div>

    <!-- 联系我们弹窗 -->
    <div class="tc_bd" v-show="showModal">
      <div class="g_b" @click="showModal = false"><i class="iconfont icon-guanbi"></i></div>
      <div class="bd_ly">
        <h3>Feel free to contact us</h3>
        <h4>If you want to cooperate with us, please leave your valuable information and we will contact you within 24 hours!</h4>
        <ul class="row">
          <li><input type="text" v-model="form.name" placeholder="Your Name"></li>
          <li><input type="text" v-model="form.phone" placeholder="Your Phone"></li>
          <li><input type="text" v-model="form.email" placeholder="Your Email"></li>
          <li><textarea v-model="form.mess" placeholder="Write Your Message"></textarea></li>
          <li><button @click="submitForm" :disabled="submitting">Send Message</button></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { addCustom } from '@/api';

export default {
  name: 'FloatBar',
  data() {
    return {
      showModal: false,
      submitting: false,
      form: {
        name: '',
        phone: '',
        email: '',
        mess: ''
      }
    }
  },
  methods: {
    // 返回顶部
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    // 提交表单
    async submitForm() {
      if (!this.form.mess) {
        this.$message({
          message: 'Please enter your message!',
          type: 'error'
        });
        return;
      }
      this.submitting = true;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      try {
        let data = await addCustom(this.form);
        loading.close();
        if (data.code == 200) {
          this.$message({
            message: 'Send Success！',
            type: 'success'
          });
          this.form = { name: '', phone: '', email: '', mess: '' };
          this.showModal = false;
        } else {
          this.$message({
            message: data.message || 'Submit Failed',
            type: 'error'
          });
        }
      } catch (e) {
        loading.close();
        this.$message({
          message: 'Network Error',
          type: 'error'
        });
      }
      this.submitting = false;
    }
  }
}
</script>

<style scoped>
</style>
